import { render, staticRenderFns } from "./PostMappingCreate.vue?vue&type=template&id=a9bb7874&scoped=true"
import script from "./PostMappingCreate.vue?vue&type=script&lang=js"
export * from "./PostMappingCreate.vue?vue&type=script&lang=js"
import style0 from "./PostMappingCreate.vue?vue&type=style&index=0&id=a9bb7874&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9bb7874",
  null
  
)

export default component.exports